export default {"src":"/_next/static/media/figma.00471f51.svg","height":384,"width":256,"blurWidth":0,"blurHeight":0};